import dynamic from 'next/dynamic';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import {
  ActionsCreators as actions,
  Actions as IActions,
} from '../../../../../redux/actions/merchants/services';
import { ServicesState } from '../../../../../redux/reducers/merchants/services';
import * as T from '../../../../../redux/types/merchants/services';
import { ComponentProps as FullCalendarProps } from '../../../../../molecules/merchant/calendar/MerchantWidgetCalendar';
import { MerchantDetail } from '../../../../../interfaces/merchants';

interface StateProps {
  baseDate: string;
  fetchedUntil: string;
  viewStyle: T.ViewStyle;
}

interface DispatchProps {
  actions: {
    handleCalendarClick: () => void;
    handleListClick: () => void;
    load: (publicId: string, baseDate: string, fetchedUntil: string) => void;
    movePrev: () => void;
    moveNext: () => void;
    scrollNext: () => void;
  };
}

interface MerchantWidgetCalendarPageProps {
  merchantDetail: MerchantDetail;
  calendarViewStyle: string;
  ga?: string;
  gl?: string;
  servicePublicIds?: string[];
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  ga_client_id?: string;
  ga_session_id?: string;
}
type Props = StateProps & DispatchProps & MerchantWidgetCalendarPageProps;

const MerchantWidgetCalendar = dynamic<FullCalendarProps>(
  import('../../../../../molecules/merchant/calendar/MerchantWidgetCalendar').then(
    (c) => c.default,
  ),
  {
    loading: () => <span />,
    ssr: false,
  },
);

const MerchantWidgetCalendarPage: React.FC<Props> = ({
  baseDate,
  merchantDetail,
  calendarViewStyle,
  ga,
  gl,
  servicePublicIds,
  utm_campaign,
  utm_medium,
  utm_source,
  ga_client_id,
  ga_session_id,
}) => {
  return (
    <MerchantWidgetCalendar
      merchantPublicId={merchantDetail.public_id}
      merchantTimeZone={merchantDetail.time_zone}
      baseDate={baseDate as string}
      business_hours={merchantDetail.business_hours}
      calendarViewStyle={calendarViewStyle}
      ga={ga}
      gl={gl}
      servicePublicIds={servicePublicIds}
      utm_campaign={utm_campaign}
      utm_medium={utm_medium}
      utm_source={utm_source}
      ga_client_id={ga_client_id}
      ga_session_id={ga_session_id}
    />
  );
};

const mapStateToProps = (state: {
  merchantsServices: ServicesState;
}): StateProps => {
  return { ...state.merchantsServices };
};

const mapDispatchToProps = (dispatch: Dispatch<IActions>): DispatchProps => ({
  actions: {
    handleCalendarClick: () =>
      dispatch(actions.switchViewStyle(T.ViewStyle.Calendar)),

    handleListClick: () => dispatch(actions.switchViewStyle(T.ViewStyle.List)),

    moveNext: () => dispatch(actions.moveNext()),

    movePrev: () => dispatch(actions.movePrev()),

    load: (publicId: string, baseDate: string, fetchedUntil: string) => {
      actions
        .load(publicId, baseDate, fetchedUntil)
        .then((ac) => ac && dispatch(ac));
    },

    scrollNext: () => {
      dispatch(actions.scrollNext());
    },
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MerchantWidgetCalendarPage);
